<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 11:11:55
 * @Description: 大屏公共头部
 * @FilePath: \sheyang\src\module\header\index.vue
-->
<template>
  <div class="screen-header">
    <img class="animated-bg" src="@/assets/images/apng/headerImg.png" alt="" />
    <div class="nav">
      <span
        v-for="item in navData"
        class="nav-item"
        :class="[item.isActive ? 'nav-active' : '']"
        :key="item.id"
        @click="navLinkTo(item.url)"
      >
        {{ item.name }}
      </span>
    </div>
    <!-- 标题 -->
    <div class="title-container">
      <img class="title-logo" src="@/assets/images/logo.png" alt="" />
      <p class="big-title">三维集团充电桩运维监管平台</p>
    </div>
    <!-- 时间天气 -->
    <div class="more-info">
      <div class="time-container">
        <span class="clock">{{ currentClock }}</span>
        <div class="date-info">
          <span class="day-of-week">{{ dayOfWeek }}</span>
          <span class="date">{{ date }}</span>
        </div>
      </div>
      <div class="divide-line" />
      <div class="weather-container">
        <div class="weather-img">
          <i :class="`qi-${weather.weatherImg}`" class="img-style"></i>
          <!-- <img class="img-style" src="@/assets/images/weather-sunny.png" alt=""> -->
        </div>
        <div class="degree-icon">
          <img class="img-style" src="@/assets/images/degree-icon.png" alt="" />
        </div>
        <div class="degree-number">{{ weather.degree }}℃</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';

let weatherTimer = null;

let currentTimer = null;

export default {
  name: 'screenHeader',
  computed: {
    ...mapGetters({
      navData: 'navData',
    }),
  },
  data() {
    return {
      currentRoute: '', // 当前激活路由
      currentClock: '00:00:00', // 当前时间
      dayOfWeek: '星期一', // 周几
      date: '----.--.--', // 日期
      weather: {
        weatherImg: '100', // 天气图片
        degree: 0, // 温度
      },
    };
  },
  watch: {
    $route(newVal, oldVal) {
      this.currentRoute = newVal.path;
    },
    currentRoute(newVal, oldVal) {
      console.log('当前路由', newVal);
      this.changeNavItemsActive(newVal);
    },
  },
  mounted() {
    this.getWeatherInfo();
    weatherTimer = window.setInterval(() => {
      this.getWeatherInfo();
    }, 1000 * 60 * 60);
    this.$router.onReady(() => {
      this.currentRoute = this.$route.path;
    });
    currentTimer = window.setInterval(() => {
      this.getTime();
    }, 1000);
  },
  beforeDestroy() {
    if (currentTimer) {
      clearInterval(currentTimer);
      currentTimer = null;
    }
    if (weatherTimer) {
      clearInterval(weatherTimer);
      weatherTimer = null;
    }
  },
  methods: {
    ...mapActions({
      changeNavItemsActive: 'changeNavItemsActive',
    }),
    navLinkTo(url) {
      this.$router.push(url);
      // this.changeNavItemsActive(url);
      this.currentRoute = url;
    },
    // 更改 nav 激活
    // changeNavItemsActive(url) {
    //   this.navData.forEach((v, i) => {
    //     if (v.url === url) {
    //       this.$set(this.navData, i, { ...v, isActive: true });
    //     } else {
    //       this.$set(this.navData, i, { ...v, isActive: false });
    //     }
    //   });
    // },
    // 大屏实时时间
    getTime() {
      const dateObj = new Date();
      const year = dateObj.getFullYear();// 年
      let month = dateObj.getMonth() + 1;// 月  (注意：月份+1)
      let date = dateObj.getDate();// 日
      const day = dateObj.getDay();
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const week = weeks[day];// 根据day值，获取星期数组中的星期数。
      let hours = dateObj.getHours();// 小时
      let minutes = dateObj.getMinutes();// 分钟
      let seconds = dateObj.getSeconds();// 秒
      // 字符串格式化
      month = this.formatStringNumber(month);
      date = this.formatStringNumber(date);
      hours = this.formatStringNumber(hours);
      minutes = this.formatStringNumber(minutes);
      seconds = this.formatStringNumber(seconds);

      this.currentClock = `${hours}:${minutes}:${seconds}`;
      this.dayOfWeek = week;
      this.date = `${year}.${month}.${date}`;
    },
    // 格式化字符串数字
    formatStringNumber(num) {
      return num < 10 ? `0${num}` : `${num}`;
    },
    // 获取天气信息
    getWeatherInfo() {
      const params = {
        // appid: 21251688,
        // appsecret: '0bi3CCwi',
        key: '43215b2e67f645f88dd079b4258c6e5d',
        location: '120.33,33.77',
      };
      // 和风天气 https://api.qweather.com/v7/weather/now
      axios.get('https://devapi.qweather.com/v7/weather/now', { params }).then((res) => {
        if (res.data.code === '200') {
          const { now } = res.data;
          const { temp, icon } = now;
          this.weather = {
            weatherImg: icon,
            degree: temp,
          };
        } else {
          this.$message.error('获取天气信息失败');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.screen-header {
  width: 1920px;
  height: 80px;
  position: relative;
  overflow: hidden;
  .animated-bg {
    width: 1920px;
    height: 207px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .nav {
    height: 44px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 30px;
    left: 21px;
    .nav-item {
      width: 100px;
      height: 44px;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
      &:last-child {
        width: 130px;
      }
    }
    .nav-active {
      width: 120px;
      height: 45px;
      background-image: url('@/assets/images/nav-active-bg.png');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      text-shadow: 0px 0px 8px #00B2FF;
    }
  }
  .title-container {
    display: flex;
    align-items: center;
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    .title-logo {
      width: 46px;
      height: 39px;
      margin-right: 15px;
    }
    .big-title {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 42px;
      text-shadow: 0px 0px 8px #33B6FF;
      background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
  }
  // 时间天气容器
  .more-info {
    display: flex;
    align-items: center;
    position: absolute;
    top: 36px;
    right: 56px;
    .time-container {
      display: flex;
      align-items: center;
      .clock {
        margin-right: 22px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 40px;
        text-shadow: 0px 0px 8px #00B2FF;
      }
      .date-info {
        display: flex;
        flex-direction: column;
      }
      .day-of-week {
        margin-bottom: 2px;
      }
      .day-of-week, .date {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-shadow: 0px 0px 8px #00B2FF;
      }
    }
    .divide-line {
      width: 1px;
      height: 16px;
      background: #979797;
      margin: 0 20px;
    }
    .weather-container {
      display: flex;
      align-items: center;
      .weather-img {
        width: 37px;
        height: 37px;
        margin-right: 8px;
        line-height: 37px;
        text-align: center;
        color: #fff;
        font-size: 24px;
        .img-style {
          width: 37px;
          height: 37px;
        }
      }
      .degree-icon {
        width: 24px;
        height: 24px;
        margin-right: 4px;
        line-height: 24px;
        text-align: center;
        .img-style {
          width: 11px;
          height: 21px;
        }
      }
      .degree-number {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        text-shadow: 0px 0px 8px #00B2FF;
      }
    }
  }

}
</style>
